exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".receipt-amount {\n  margin-top: 6rem;\n}\n\n.receipt-amount .receipt-amount__amounts {\n  padding: 0 3.5rem 2rem !important;\n  max-width: 60rem;\n  margin: 4rem auto 0;\n}\n\n", ""]);

// exports
